module.exports = __webpack_public_path__ + "img/dark-green-square-table-8.3143d408.png";